import DatePicker from 'forms/scripts/datepicker'

$(function () {
  DatePicker.init()
})
